import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMapSlice } from '../../../slice';
import { selectCultureAndNotCultureFields } from '../../../slice/selectors';
import { IMappedField, MapModeEnum } from '../../../slice/types';
import DisabledField from '../../fields/DisabledField/DisabledField';
import { Field } from '../../fields/Field/Field';

const CultureFields = () => {
  const { cultureFields, notCultureFields } = useSelector(
    selectCultureAndNotCultureFields,
  );
  const dispatch = useDispatch();

  const { actions } = useMapSlice();

  useEffect(() => {
    if (cultureFields.length) {
      dispatch(actions.fitAllPolygonsOnMap());
    }
  }, [dispatch, actions, cultureFields.length]);

  const onFieldClick = (field: IMappedField) => {
    dispatch(actions.zoomOnPolygon(field.fieldParameters.fieldId));
  };

  return (
    <>
      {cultureFields.map(mappedField => (
        <Field
          mode={MapModeEnum.view}
          eventHandlers={{
            click() {
              onFieldClick(mappedField);
            },
          }}
          mappedField={mappedField}
          key={mappedField.id}
          isSelected={true}
        />
      ))}

      {notCultureFields.map(mappedField => (
        <DisabledField mappedField={mappedField} key={mappedField.id} />
      ))}
    </>
  );
};

export default CultureFields;
